var _g;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgSchedule = function SvgSchedule(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1923 -1279)"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "currentColor",
    opacity: 0,
    width: 24,
    height: 24,
    transform: "translate(1947 1279) rotate(90)"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0,
    fill: "none",
    strokeLinejoin: "round",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeWidth: "2px",
    transform: "translate(1928 1284)"
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0,0H12a2,2,0,0,1,2,2V12a2,2,0,0,1-2,2H0a0,0,0,0,1,0,0V0A0,0,0,0,1,0,0Z"
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "none",
    x: 1,
    y: 1,
    width: 12,
    height: 12,
    rx: 1
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0,
    fill: "none",
    strokeLinejoin: "round",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeWidth: "2px",
    transform: "translate(1931 1284)"
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0,0H9a2,2,0,0,1,2,2V12a2,2,0,0,1-2,2H0a0,0,0,0,1,0,0V0A0,0,0,0,1,0,0Z"
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "none",
    x: 1,
    y: 1,
    width: 9,
    height: 12,
    rx: 1
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.5 -0.5)"
  }, /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeWidth: "2px",
    x2: 10,
    transform: "translate(1929.5 1292.5)"
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeWidth: "2px",
    x2: 6,
    transform: "translate(1931.5 1296.5)"
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeWidth: "2px",
    y1: 1,
    transform: "translate(1934.5 1287.5)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M570.5,176a4,4,0,0,0-4-4,1,1,0,0,0,0,2,2,2,0,0,1,0,4,1,1,0,0,0,0,2A4,4,0,0,0,570.5,176Z",
    transform: "translate(1758.5 1858) rotate(-90)"
  })))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgSchedule, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/schedule.5cbbc25e.svg";
export { ForwardRef as ReactComponent };